export default __webpack_public_path__ + "static/media/bannerSmall1.3606c305.png";